import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { Milestone } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type MilestoneModel = getEntityType<MilestoneState>;

export type MilestoneState = EntityState<
  Omit<RequireSome<Partial<Milestone>, 'id'>, 'milestone_category'>
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'milestone' })
export class MilestoneStore extends EntityStore<MilestoneState> {
  constructor() {
    super({});
  }
}
